import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { AuthContext } from "../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { MultiSelect } from 'primereact/multiselect';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { Button } from 'primereact/button';
import CustomDropdown from '../../../custom/customDropdown';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import useVisinaTabele from "../../../custom/visinaTabele";


const PregledAkontacijaZaPeriod = () => {
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const user = useSelector(state => state.user)
        const [idAcontation, setIdAcontation] = useState(null);
        const [izabran, setIzabran] = useState(false)
                const [selectedRowIdAcontation , setSelectedRowIdAcontation] = useState(null);
                const isSelected = (row) => String(getIdExpence(row)) === String(selectedRowIdAcontation);
        
                const [globalFilter, setGlobalFilter] = useState(null);
                const [first, setFirst] = useState(0);
                const [tableData, setTableData] = useState(null);
                const [allColumns, setAllColumns] = useState([]);
                const [selectedColumns, setSelectedColumns] = useState([]);
                 const [originalColumnOrder, setOriginalColumnOrder] = useState([]);

        const getIdExpence = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        const [porukaTimeRange, setPorukeTimeRange] = useState(null)
        const [formSubmitted, setFormSubmitted] = useState(false);
 //DATA
   const [formData, setFormData] = useState({
         datumOd: null,
         datumDo: null
         });
   /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
   const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([tableData]);

        

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formData) {
            if(name == 'datumDo'){
                if(formData.datumOd && formData.datumOd >= value) {
                    setFormData(prev => ({ ...prev, ['datumDo']: null }));
                    setPorukeTimeRange('Datum OD ne može biti veći od datuma DO!')
                    return
                } else {
                if(porukaTimeRange != null)
                    setPorukeTimeRange(null)
                    setFormData(prev => ({ ...prev, [name]: value }));
                }
            }
             if(name == 'datumOd'){
                if(formData.datumDo && formData.datumDo <= value) {
                    setFormData(prev => ({ ...prev, ['datumOd']: null }));
                    setPorukeTimeRange('Datum OD ne može biti veći od datuma DO!')
                    return
                } else {
                if(porukaTimeRange != null)
                    setPorukeTimeRange(null)
                    setFormData(prev => ({ ...prev, [name]: value }));
                }
            }
        }

    };

    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const generisiPregled = ()=>{

        let datumOd = toUtcIso(formData.datumOd)
        let datumDo = toUtcIso(formData.datumDo)

                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  datumOD: datumOd,
                                  datumDO: datumDo
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/finance/GetAcontacion", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                  

                                setTableData(data)


                                if (data && data.length > 0) {
                                                const columns = Object.keys(data[0])
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: key,
                                                    value: key
                                                    }));
                                        
                                                 
                                                setAllColumns(columns);
                                                  const originalOrder = Object.keys(data[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
}

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      generisiPregled()
   }

const handleDeleteFunc = () => {
       
            confirmDialog({
            message: "Želite obrisati akontaciju?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async () => {

 setFormSubmitted(true)

  if (idAcontation) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idAcontation
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/finance/DeleteAcontacion", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešna brisanje akontacije!",
                life: 3000,
                });
                setFormSubmitted(false)
                setIdAcontation(null)
                setIzabran(false)
                setSelectedRowIdAcontation(null)
                generisiPregled()
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali akontaciju za brisanje!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 



  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Akontacije za period');
  
      const headers = selectedColumns;

      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Akontacije za period - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
         <div className="export-buttons fakture-stavke-header">
          <div className="fakture-stavke-radnje">
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" style={{marginRight:'1%'}}/>
              {selectedRowIdAcontation && <Button type="button" style={{marginLeft:'1%'}} icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFunc} data-pr-tooltip="Delete" />}
          </div>
          <input type="search" className="p-inputtext p-component"
                 onInput={(e) => setGlobalFilter(e.target.value)}
                 placeholder={t('nova.phPretraga')}
                 />
        </div>
      );

     const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseAcontation = (rowData) => {
        const id = getIdExpence(rowData);

        setSelectedRowIdAcontation((prev) => {
        const next = String(prev) === String(id) ? null : String(id);

        if(next) {
        setIdAcontation(next)
        setIzabran(true) 
        }
        else {
        setIdAcontation(null)
        setIzabran(false) 
        }

        return next;
    });
    }

     const previewBodyTemplateWork = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseAcontation(rowData)}
              />
            
        </div>
      );
    };

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />        
        <ConfirmDialog/>
                <form autoComplete="off" ref={formRef} style={{margin:'1% 0 1% 0',display: 'flex'}}>
                <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column', maxWidth: '200px'}}>
                                        <label htmlFor="datumOd">{t('ture.datumOd')}:</label>
                                        <Calendar 
                                            showIcon 
                                            dateFormat="dd.mm.yy"
                                            id="datumOd" 
                                            name="datumOd" 
                                            required
                                            invalid={invalidControl(formData.datumOd)}
                                            value={formData.datumOd} 
                                            onChange={handleChange} 
                                            mask="99.99.9999"
                                        />
                                    </div>
                                     <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column', maxWidth: '200px'}}>
                                        <label htmlFor="datumDo">{t('ture.datumDo')}:</label>
                                          {porukaTimeRange && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaTimeRange}</p>}
                                        <Calendar 
                                            showIcon 
                                            dateFormat="dd.mm.yy"
                                            id="datumDo" 
                                            name="datumDo" 
                                            required
                                            invalid={invalidControl(formData.datumDo)}
                                            value={formData.datumDo} 
                                            onChange={handleChange} 
                                            mask="99.99.9999"
                                        />
                                    </div>
                                    <div className="formUnosZap" style={{display:'flex',flexDirection:"column", justifyContent:'end'}}>
                                        <button type="submit" onClick={handleFormSubmit} style={{minWidth:"fit-content", textAlign:'center',verticalAlign:'center', fontSize:'100%'}} className="btn btn-success">
                                           GENERIŠI
                                        </button>
                                    </div>
                </form>
                          <Card className="tabela-kartica">
                               <Tooltip target=".export-buttons>button" position="bottom" />
                                     {/* Izbor kolona ide iznad tabele; kad kolona nema, traka se ne crta —
                                         prazan div bi ostavio rupu između forme i zaglavlja tabele. */}
                                     {allColumns.length > 0 && (
                                       <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1%" }}>
                                         <div style={{ width: "20%" }}>
                                           <MultiSelect
                                           value={selectedColumns}
                                           options={allColumns}
                                           onChange={(e) => {
                                           const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
                                           setSelectedColumns(sorted);
                                           }}
                                           optionLabel="label"
                                           display="chip"
                                           placeholder={t('nova.odaberiteKolone')}
                                           style={{ width: '100%' }}
                                           showSelectAll={true}
                                           filter
                                           filterPlaceholder="Pretraži kolone"
                                           maxSelectedLabels={3}
                                           selectedItemsLabel="{0} kolona odabrano"
                                           />
                                         </div>
                                       </div>
                                     )}
                                   <div ref={omotTabele}>
                                   <DataTable
                                          value={tableData || []}
                                          paginator
                                          rows={redovaTabele}
                                          first={first}
                                          globalFilter={globalFilter}
                                          onPage={(e) => setFirst(e.first)}
                                          scrollable
                                          header={header}
                                          scrollHeight={visinaTabele}
                                          emptyMessage={t('common.noDataTable')}
                                          resizableColumns
                                          className="turePregledTable stavke-tabela"
                                          columnResizeMode="expand"
                                          rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                        >
                                          {selectedColumns.map((colKey) => {
                                          const colMeta = allColumns.find(col => col.value === colKey);
                                          return (
                                            <Column
                                              key={colKey}
                                              field={colKey}
                                              header={colMeta?.label || colKey}
                                              sortable
                                              body={(rowData) => {
                                                if (isButtonColumn(colKey)) {
                                                  return previewBodyTemplateWork(rowData, colKey);
                                                }
                                                return rowData[colKey] || '-';
                                              }}
                                              style={{ minWidth: '150px'}}
                                            />
                                          );
                                        })}
                                    </DataTable>
                                   </div>
                          </Card>
            </div>
)
}
export default PregledAkontacijaZaPeriod;